import React, { useState } from 'react';
import './App.css';
import { HashRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import GuestList from './components/guestlist';
import QRScanner from './components/qrScanner';
import Login from './components/login';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import './config/FirebaseConfig';

function AppContent() {
  const navigate = useNavigate();
  const [authChecked, setAuthChecked] = useState(false);
  const [user, setUser] = useState(null);

  React.useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setAuthChecked(true);
      if (!u) {
        navigate('/login');
        return;
      }
      // if staff user (email contains @staff.com) redirect to /qr immediately
      try {
        const email = u.email && String(u.email).toLowerCase();
        if (email && (email.includes('@staff.com') || email.includes('@tempstaff.com'))) {
          navigate('/qr');
        }
      } catch (e) {
        // ignore
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  if (!authChecked) return null; // or a loading spinner

  return (
    <div className="App" style={{ position: 'relative' }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            // prevent staff users from accessing GuestList; redirect them to /qr
            user && user.email && (String(user.email).toLowerCase().includes('@staff.com') || String(user.email).toLowerCase().includes('@tempstaff.com')) ? (
              <Navigate to="/qr" replace />
            ) : (
              <GuestList />
            )
          }
        />
        <Route path="/qr" element={<QRScanner />} />
      </Routes>
    </div>
  );
}

const theme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        circle: {
          strokeLinecap: 'round',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#023020',
    },
  },
});

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AppContent />
      </ThemeProvider>
    </Router>
  );
}

export default App;
